module.exports = __webpack_public_path__ + "img/escudo.f40b7d36.svg";